//
//
//
//
//
//
//
//
//
//
//
//

export default {
	name: 'IconArrow',

	props: {
		mod: {
			default: ''
		},
		type: {
			default: ''
		}
	},

	computed: {
		modClass: function modClass() {
			var arr = [];

			this.mod.split(' ').forEach(function (el) {
				arr.push('icon-arrow--' + el);
			});

			return arr;
		}
	}
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/babel-loader/lib?{"babelrc":false,"cacheDirectory":true,"presets":[["/app/node_modules/babel-preset-vue-app/dist/index.common.js",{"targets":{"ie":9,"uglify":true}}]]}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./components/IconArrow.vue
// module id = ./node_modules/babel-loader/lib/index.js?{"babelrc":false,"cacheDirectory":true,"presets":[["/app/node_modules/babel-preset-vue-app/dist/index.common.js",{"targets":{"ie":9,"uglify":true}}]]}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./components/IconArrow.vue
// module chunks = 5